








import { Component, Vue } from "vue-property-decorator";
import FormularioChapuzonKids2025 from "@/components/Formularios/FormularioChapuzonKids2025.vue";

@Component({
  components: {
    FormularioChapuzonKids2025
  },
  meta: {
    // sets document title
    title:
      "Chapuzón Kids en el Estrecho 2025 - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class CarnavalView extends Vue {
  private mounted() {
    document.title =
      "Chapuzón Kids en el Estrecho 2025- Ilustre Municipalidad de Punta Arenas";
  }
}
